import { PlusIcon } from "@xola/icons";
import { Breadcrumb, Button, HeaderToolbar } from "@xola/ui-kit";
import React from "react";
import { useHistory } from "react-router-dom";
import { Permission } from "types";
import { IsGranted } from "../components/Common/IsGranted";
import { SecondaryButton } from "../components/Common/SecondaryButton";
import { ColumnLayout } from "../components/Layout/ColumnLayout";
import { EquipmentManagement } from "../components/Resources/EquipmentManagement/EquipmentManagement";
import { EmbeddedAppTriggerLocation } from "../embeddedApps/EmbeddedAppTriggerLocation";
import { Page } from "./Page";

export const EquipmentListPage = () => {
    const history = useHistory();
    const handleGlobalSettingsClick = () => {
        history.push("/resources/equipment/settings");
    };

    const handleCreateClick = () => {
        history.push("/resources/equipment/create");
    };

    return (
        <Page title="Equipment Management">
            <ColumnLayout>
                <HeaderToolbar>
                    <HeaderToolbar.Breadcrumb className="flex-grow">
                        <Breadcrumb.Item>Resources</Breadcrumb.Item>
                        <Breadcrumb.Item>Equipment Management</Breadcrumb.Item>
                    </HeaderToolbar.Breadcrumb>
                    <EmbeddedAppTriggerLocation id="resources.equipment.headerBar" />
                    <IsGranted permissions={Permission.RESOURCES_EQUIPMENT_SETTINGS_VIEW}>
                        <SecondaryButton
                            className="flex-shrink-0"
                            data-testid="equipment-list-page-global-settings-button"
                            onClick={handleGlobalSettingsClick}
                        >
                            Global Settings
                        </SecondaryButton>
                    </IsGranted>
                    <Button
                        className="flex-shrink-0"
                        icon={<PlusIcon />}
                        data-testid="equipment-list-page-create-button"
                        onClick={handleCreateClick}
                    >
                        Create
                    </Button>
                </HeaderToolbar>
                <ColumnLayout.Fill>{(height) => <EquipmentManagement height={height} />}</ColumnLayout.Fill>
            </ColumnLayout>
        </Page>
    );
};
